// Бэкенд отдаёт суммы уже в рублях (cashier/menu.service.ts → fromKop, orderToDto → fromKop).
// Поэтому здесь НИЧЕГО не делим: просто округляем и форматируем.
export function formatRub(rub: number): string {
  const v = Number.isFinite(rub) ? rub : 0;
  return `${v.toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })} ₽`;
}

export function formatDate(iso: string | Date): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return d.toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export function formatPhone(input: string): string {
  const digits = input.replace(/\D/g, '').replace(/^8/, '7');
  const p = digits.slice(-10);
  if (p.length < 10) return '+' + digits;
  return `+7 (${p.slice(0, 3)}) ${p.slice(3, 6)}-${p.slice(6, 8)}-${p.slice(8, 10)}`;
}

export const statusLabel: Record<string, string> = {
  NEW: 'Принят',
  IN_PROGRESS: 'Готовится',
  READY: 'Готов',
  COMPLETED: 'Выполнен',
  CANCELLED: 'Отменён',
};
